import ListOut from './ListOut'
import JsonLdFAQ from 'src/seo/jsonld/JsonLdFAQ'
import strip from '@utils/html/strip'
import defaultStyles from 'styles/FAQ.module.css'

function FAQComponent ({
    explicitTitle,
    includeJsonLd = true,
    page = 'generic-faq',
    qa,
    styles = defaultStyles,
    title = 'Samochody.pl',
}) {
    if (qa?.title) { // accept object format with title (default - array of qa)
        if (title !== null) title = qa.title
        qa = qa.qa || qa.qaArray
    }

    if (!qa) return null

    return (
        <section key={page} className={`${styles.wrapper} container`}>
            { includeJsonLd && <JsonLdFAQ qa={qa} />}
            { title !== null && <>
                <h2>{ explicitTitle || `${title} FAQ:` }</h2>
                <br/>
            </> }
            { renderFAQItems(qa, styles) }
        </section>
    )
}

function renderFAQItems (qa, styles) {
    return <ListOut items={qa} styles={styles} Component={FAQItem} />
}

function FAQItem ({ question, answer, keywords, styles }) {
    const answerHtml = activateLinks(
        boldenKeywords(answer, keywords))

    return (
        <details className={styles.qa_item}>
            <summary>{ strip(question) }</summary>
            <div className={styles.answer}
                dangerouslySetInnerHTML={{ __html: answerHtml }}/>
        </details>
    )
}

function activateLinks (text) {
    if (typeof text !== 'string') return ''
    const LINK_TEXT = 'Samochody.pl'
    const REGEXP = /(https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/
    const LINK = href => `<a href="${href}">${LINK_TEXT}</a>`
    const linkExists = text.indexOf('<p>') == -1 && text.lastIndexOf('https') !== -1 // do not do for html
    let newText
    if (linkExists) {
        const match = text.match(REGEXP)
        if (match) {
            const [href] = match
            const index = match.index
            const length = href.length
            newText = text.slice(0, index) + LINK(href) + text.slice(index + length)
        }
    }

    return newText || text
}

function boldenKeywords (text, keywordArray = [], startWhiteSpace = '\\s+', endWhiteSpace = '\\s+', startTag = ' <b>', endTag = '</b> ') {
    for (const keyword of keywordArray) {
        const regexp = new RegExp(`${startWhiteSpace}${keyword}${endWhiteSpace}`, 'g')
        const chunks = text.split(regexp)
        text = chunks.join(`${startTag}${keyword}${endTag}`)
    }

    return text
}

export default FAQComponent
export { activateLinks, boldenKeywords }